
  
  class SocialShare extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    init() {
        this.querySelectorAll('.btn-sharing').forEach(share => {
            share.addEventListener("click", event => {
              event.preventDefault();
              const target = event.currentTarget;
              const social = target.getAttribute('data-social');
              window.open(social);
            }, false);
        });
    }
  }
  customElements.define("social-share", SocialShare);
  
document.querySelectorAll(".faq-question").forEach(btn => {

btn.addEventListener("click", function(){

const answer = this.nextElementSibling;
const expanded = this.getAttribute("aria-expanded") === "true";

document.querySelectorAll(".faq-question").forEach(b=>{
b.setAttribute("aria-expanded","false");
});

document.querySelectorAll(".faq-answer").forEach(a=>{
a.style.display="none";
});

if(!expanded){
answer.style.display="block";
this.setAttribute("aria-expanded","true");
}

});

});